import React from 'react'
import ReactDOM from 'react-dom/client'
import { initSentry } from './core/monitoring/sentry'
import { AppErrorBoundary } from './core/monitoring/ErrorBoundary'
import './i18n/config' // Initialize i18n
import App from './App'
import './index.css'

// Initialize error monitoring before rendering
initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
)